module.exports = __webpack_public_path__ + "static/media/download-white.d2c1ca0a.svg";